const common = {
  login: 'Login',
  signin: 'Sign In',
  logout: 'Log Out',
  forgotPassword: 'Forgot Password',
  copyright: 'Copyright©',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  poweredBy: 'Powered by',
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',
  photo: 'Photo',
  photoViewer: 'Photo Viewer',
  review: 'Review',
  fullName: 'Full Name',
  upTo: 'up to',
  actions: 'Actions',
  edit: 'Edit',
  editMode: 'Edit Mode',
  list: '{{name}} List',
  addRemove: 'Add/Remove {{name}}',
  delete: 'Delete {{name}}',
  create: 'Create',
  rememberMe: 'Remember Me',
  yes: 'Yes',
  update: 'Update',
  active: 'Active',
  no: 'No {{name}}',
  selfService: 'Self-Service',
  print: 'Print',
  inviteOnly: 'Invite Only',
  inactive: 'Inactive',
  download: 'Download {{name}}',
  clear: 'Clear',
  quickLinks: 'Quick Links',
  general: 'General',
  price: 'Price',
  cost: 'Cost',
  submit: 'Submit',
  select: 'Select {{name}}',
  options: 'Options',
  field: 'Field',
  row: 'Row',
  date: 'Date',
  information: 'Information',
  groupName: 'Group Name',
  rulesetName: 'Ruleset Name',
  page: 'Page',
  service: 'Service',
  status: 'Status',
  reason: 'Reason',
  health: 'Health',
  restriction: 'Restriction',
  requested: 'Requested',
  accessLogs: 'Access Logs',
  searching: 'Searching...',
  noOptions: 'No {{name}} found',
  from: 'From {{name}}',
  send_password_reset_email: 'Send Password Reset Email',
  tryDifferentSearch: 'Try a different search',
  enterTextToSearch: 'Enter text to search',
  details: 'Details',
  custom: 'Custom',
  settings: 'Settings',
  setup: 'Setup',
  sunday: 'Sunday',
  sunday_short: 'Sun',
  sunday_shortest: 'Su',
  monday: 'Monday',
  monday_short: 'Mon',
  monday_shortest: 'M',
  tuesday: 'Tuesday',
  tuesday_short: 'Tue',
  tuesday_shortest: 'T',
  wednesday: 'Wednesday',
  wednesday_short: 'Wed',
  wednesday_shortest: 'W',
  thursday: 'Thursday',
  thursday_short: 'Thu',
  thursday_shortest: 'Th',
  friday: 'Friday',
  friday_short: 'Fri',
  friday_shortest: 'F',
  saturday: 'Saturday',
  saturday_short: 'Sat',
  saturday_shortest: 'Sa',
  everyday: 'Everyday',
  weekdays: 'Weekdays',
  weekends: 'Weekends',
  minutes: 'Minutes',
  minutes_short: 'min',
  hours: 'Hours',
  allDay: 'All Day',
  daysOfWeek: 'Days of the Week',
  id: 'ID',
  by: 'By',
  address: 'Address',
  location: 'Location',
  template: 'Template',
  csv: 'CSV',
  optional: 'Optional',
  required: 'Required',
  content: 'Content',
  permanent: 'Make URL permanent',
  cannot_update_pending_user: 'Cannot update pending user contact information',
  cannot_update_external_user_roles: 'Cannot update roles for external users',
  permanent_details: 'When selected the url will persist',
  content_helper_text: 'Enter valid url format ex: https://www.traxero.com',
  content_error_message:
    'invalid url enter valid url format ex: https://www.traxero.com',
  registrationBanner:
    'You are logged in with a temporary user account with limited functionality. To make this banner go away and unlock all features, ',
  registrationLink: 'register your account here',
  assignDefaultRule: 'Assign Default Rule',
  assignDefaultRule_details:
    'Create this property with a rule already assigned that includes all violations at all times',
  revision: {
    menu: 'Revisions',
    label: 'Revision',
    label_plural: 'Revisions',
    fieldMenuTitle: 'Focused Fields',
    fieldMenuTitle_field: 'Select Field',
    listTitle_view: 'Select a Revision to View',
    listTitle_diff: 'Select Two Revisions to Compare',
    listTitle_field: 'Field History',
    listTitle_access: 'Access Log',
    viewModeLabel: 'Viewer Mode',
    mode_view: 'View (single)',
    mode_diff: 'Compare',
    mode_field: 'Field History',
    mode_access: 'Access Log',
    displayLabel: 'Field Names',
    display_system: 'System',
    display_labels: 'Labels',
    accessModeLabel: 'Access Log Viewer Mode',
    accessMode_user: 'User Access Logs',
    accessMode_entity: 'Entity Access Logs',
    accessMode_tenant: 'Tenant Access Logs',
    startDate: 'Start Date',
    linkButton: 'View Revisions',
    historyFor: 'History for {{name}}',
  },
  service_health: {
    label: 'Service Health',
    label_plural: 'Service Health',
    service: {
      label: 'Service',
      label_plural: 'Services',
      user: 'User Service',
      file: 'File Service',
      vehicle: 'Vehicle Service',
      property: 'Property Service',
      job: 'Job Service',
      revision: 'Revision Service',
      permit: 'Permit Service',
      notification: 'Notification Service',
      redirect: 'Redirect Service',
      analytics: 'Analytics Service',
      payment: 'Payment Service',
      findMyCar: 'Find My Car Service',
      qrCode: 'QR Code Service',
      permitClient: 'Permit Client Service',
    },
    status: {
      label: 'Status',
      label_plural: 'Statuses',
      pass: 'Pass',
      warn: 'Warning',
      fail: 'Fail',
      offline: 'Offline',
    },
  },
  file: {
    label: 'File',
    label_plural: 'Files',
    name: 'Name',
    type: 'Type',
    created: 'Created',
  },
  errors: {
    login400: 'Missing email or password',
    login401: 'Invalid email or password',
    login403: 'Access Denied',
    login404: 'User not found',
    login500: 'An unknown error occurred, please try again',
    fetchError: 'Error fetching {{name}}.  Status: {{status}}',
    email: 'Failed to send {{emailType}} email.  Status: {{status}}',
    unknown: 'An unknown error occurred, please try again',
    required: '{{name}} is required',
    updateError: 'Error updating {{name}}.  Status: {{status}}',
    createError: 'Could not create {{name}}.  Status: {{status}}',
    deleteError: 'Could not delete {{name}}.  Status: {{status}}',
    invalidError: 'Invalid {{name}}',
    invalidGreaterThan: '{{name}} must be greater than {{value}}',
    accessDenied: 'Access Denied',
    accessDeniedMessage:
      'Your account does not have permission to view this content',
    notFound: '{{name}} not found',
    camera: {
      loading: 'Could not initialize camera',
      capturing: 'Could not capture image',
      processing: 'Error processing image',
      noVehicle: 'No vehicle detected in image',
    },
    whoops: 'Whoops!',
    parse: 'Error Parsing {{name}}',
  },
  camera: {
    label: 'Camera',
    capturing: 'Take a photo of the vehicle',
    loading: 'Initializing Camera',
    processing: 'Processing Image',
    validation: 'Verify Vehicle Information',
    captureButton: 'Capture',
    retakeButton: 'Retake Image',
  },
  links: {
    home: 'Back to Home',
    support: 'Contact Traxero Support',
  },
  buttons: {
    makePrimary: 'Make Primary Contact',
    download: 'Download {{name}}',
    delete: 'Delete {{name}}',
    upload: 'Upload {{name}}',
    update: 'Update {{name}}',
    discard: 'Discard {{name}}',
    import: 'Import {{name}}',
    edit: 'Edit {{name}}',
    view: 'View {{name}}',
    remove: 'Remove {{ name }}',
    add: 'Add {{ name }}',
    create: 'Create New {{ name }}',
    configure: 'Configure {{ name }}',
    disable: 'Disable {{ name }}',
    enable: 'Enable {{ name }}',
    cancel: 'Cancel {{ name }}',
    save: 'Save {{ name }}',
    exportSelectedCsv: 'Export Selected to CSV',
    exportSelectedPdf: 'Export Selected to PDF',
    exportAllCsv: 'Export All to CSV',
    exportAllPdf: 'Export All to PDF',
    moreActions: 'More actions',
    submit: 'Submit',
  },
  tabMenu: {
    branding: 'Branding',
    create: 'Create',
    properties: 'Properties',
    property_groups: 'Property Groups',
    'property-groups': 'Property Groups',
    property_group: 'Property Groups',
    property: 'Property',
    people: 'People',
    settings: 'Settings',
    users: 'Users',
    user: 'Users',
    'rule-config': 'Rule Management',
    rules: 'Rules',
    rule: 'Rules',
    rulesets: 'Rulesets',
    ruleset: 'Rulesets',
    contacts: 'Contacts',
    contact: 'Contacts',
    violation: 'Violations',
    violations: 'Violations',
    permits: 'Permits',
    permit: 'Permits',
    permitTypes: 'Permit Types',
    permitType: 'Permit Types',
    health: 'Service Health',
    history: 'History',
    refunds: 'Refunds',
    permissions: 'Permissions',
    revisions: 'Revisions',
    revision: 'Revisions',
    files: 'Files',
    file: 'Files',
    job: 'Jobs',
    jobs: 'Jobs',
    dashboard: 'Dashboard',
    reports: 'Reports',
    instructions: 'Instructions',
    instruction: 'Instructions',
    donottow: 'Do Not Tow',
    qrCodes: 'QR Codes',
    qrCode: 'QR Codes',
    Admin: 'Admin',
    Driver: 'Driver',
    Dispatcher: 'Dispatcher',
    Property_Manager: 'Property Manager',
    Yard_Manager: 'Yard Manager',
    Sales: 'Sales',
    Accounting: 'Accounting',
    'activity-feed': 'Activity Feed',
    logout: 'Log Out',
    systems: 'Systems',
    system: 'Systems',
    tenants: 'Divisions',
    tenant: 'Divisions',
    'tenant-groups': 'Accounts',
    'company-setup': 'Company Setup',
    'tenant-select': 'Division Select',
    'command-center': 'Command Center',
    'user-settings': 'Profile',
    'user-profile': 'My Account',
    group: 'Property Group',
    'property-group': 'Property Groups',
    'tenant-group': 'Accounts',
    'property-importer': 'Import Properties',
    import: 'Import Wizard',
  },
  signature: {
    label: 'Signature',
    placeholder: 'Use your mouse to sign here',
    placeholder_mobile: 'Use your finger to sign here',
    save: 'Save Signature',
    save_mobile: 'Save',
    saved: 'Signature Saved!',
    saved_mobile: 'Saved!',
    create: 'Create Signature',
    edit: 'Edit Signature',
  },
  registration: {
    title: 'Register Your Account',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    changeEmail: 'Change Email',
    emailInUse: 'Email is already in use',
    firstName: 'First Name',
    lastName: 'Last Name',
    duplicateAccountMessage:
      'Would you like you to combine this with your current account?',
    combine: 'Combine Accounts',
    phone: 'Phone Number',
    submit: 'Submit',
    mustContain: 'Must contain ',
    uppercase: 'uppercase',
    lowercase: 'lowercase',
    number: 'number',
    special: 'special character',
    eightOrMore: '8 or more characters',
    match: 'Passwords match',
    noMatch: 'Passwords do not match',
    emailSent: 'Email sent to {{email}}',
    success: 'Email is now registered',
  },
  combineAccounts: {
    error: "Oops! Couldn't Combine Accounts",
    success: 'Combined Accounts Successfully',
    message:
      'The email {{email}} is already registered, would you like to combine the accounts',
  },
  editor: {
    xs_preview: 'Phone',
    sm_preview: 'Tablet',
    md_preview: 'Laptop',
    ol: 'Bullet List',
    ul: 'Numbered List',
    link: 'Link',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    alignLeft: 'Align Left',
    alignCenter: 'Align Center',
    alignRight: 'Align Right',
    alignJustify: 'Align Justify',
    textStyle: 'Text',
    textStyle_title: 'Title',
    textStyle_heading: 'Heading',
    textStyle_paragraph: 'Paragraph',
    textStyle_finePrint: 'Fine Print',
  },
  payment: {
    label: 'Payment',
  },
  permitClient: {
    label: 'Permit Client',
  },
  reports: {
    title: 'Report Center',
    jobsByProperty: 'Job Count by Property',
  },
  file_dropzone: {
    dragging: 'Drop files here',
    title: 'Drop files here or click to upload',
    title_mobile: 'Tap to upload',
    loading: 'Uploading...',
    completed: 'Upload complete',
  },
};
export default common;
